import { h } from "preact";
import ProductOptionSwatchList from "./product-option-swatch-list";

export default function ProductOptionSwatchesGroup({
  groupTitle,
  optionValues,
  selectedOptionValue,
  disabledOptionValues,
  updateOptionValue,
  optionName,
  truncate,
}) {
  return (
    <div className="product-options__swatch-group">
      <div className="product-options__swatch-group-header">
        <div className="product-options__swatch-group-title">{groupTitle}</div>
      </div>
      <ProductOptionSwatchList
        legend={groupTitle}
        optionValues={optionValues}
        optionName={optionName}
        updateOptionValue={updateOptionValue}
        selectedOptionValue={selectedOptionValue}
        disabledOptionValues={disabledOptionValues}
        truncate={truncate}
      />
    </div>
  );
}
